<template>
  <div class="countdown">
    <div class="unit">
      <span class="value">{{ days }}</span>
    </div>
    <div class="divider">:</div>
    <div class="unit">
      <span class="value">{{ hours }}</span>
    </div>
    <div class="divider">:</div>
    <div class="unit">
      <span class="value">{{ mins }}</span>
    </div>
    <div class="divider">:</div>
    <div class="unit">
      <span class="value">{{ secs }}</span>
    </div>
  </div>
</template>

<script>
import { intervalToDuration } from "date-fns";
import toDate from "date-fns-tz/toDate";
export default {
  name: "Countdown",
  props: {
    end: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      now: new Date(),
      tick: null,
      days: null,
      hours: null,
      mins: null,
      secs: null,
    };
  },
  computed: {
    remaining() {
      const end = toDate(this.end, {
        timeZone: "Europe/London",
      });

      return intervalToDuration({
        start: this.now,
        end,
      });
    },
  },
  mounted() {
    this.tick = setInterval(() => {
      this.now = new Date();

      this.days = this.remaining.days.toLocaleString("en-GB", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      this.hours = this.remaining.hours.toLocaleString("en-GB", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      this.mins = this.remaining.minutes.toLocaleString("en-GB", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
      this.secs = this.remaining.seconds.toLocaleString("en-GB", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.countdown {
  display: flex;
  color: white;
  align-items: center;
  justify-content: center;
  max-width: 400px;
  margin: 0 auto;

  @include respond-above(md) {
    max-width: 750px;
  }

  .unit {
    flex: 0 0 50px;
  }

  .divider {
    @include editorial-body(24px);
    flex: 0 1 auto;
  }

  .value {
    @include editorial-body(24px);
  }

  .label {
    display: block;
    text-align: center;
    text-transform: uppercase;
    font-size: 10px;
    @include respond-above(md) {
      font-size: 20px;
    }
  }
}
</style>
